import { isTypeNavigationCardsSection } from '@platform/contentful';
import { Entry } from 'contentful';
import ContentfulNavigationCard from './ContentfulNavigationCard';
import ContentfulTableOfContentsSetting from './ContentfulTableOfContentsSetting';
import ContentfulLargeCta from './ContentfulLargeCta';
import Divider from './util/Divider';
import MarkdownText from './util/MarkdownText';
import { getFullWidthBackgroundStyles } from './util/utils';

const ContentfulNavigationCardsSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeNavigationCardsSection(entry)) {
    return null;
  }

  return (
    <div className={getFullWidthBackgroundStyles(entry)}>
      <h1 className='max-w-3xl w-full font-header font-bold text-4xl sm:text-5xl text-gray-500 my-3 mx-auto'>
        {entry.fields.header}
      </h1>
      <h2 className='max-w-3xl w-full font-header font-medium text-xl sm:text-2xl leading-6 sm:leading-7 text-gray-400'>
        {entry.fields.subHeader}
      </h2>
      <Divider className='mx-auto' />
      <MarkdownText text={entry.fields.description} />
      <div className='py-8 flex flex-col sm:flex-row gap-8 sm:gap-4 max-w-[1424px] mx-auto'>
        {entry.fields.navigationCards?.map((card, index) => (
          <ContentfulNavigationCard key={index} entry={card} />
        ))}
      </div>
      <ContentfulTableOfContentsSetting entry={entry.fields.tocSetting} />
      <ContentfulLargeCta entry={entry.fields.cta} />
    </div>
  );
};

export default ContentfulNavigationCardsSection;
